import ApiService from '@/services/core/api.service'

const UnitService = {
  async get (query) {
    return ApiService.get(`admin/units?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/units', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/units/${payload.id}`, payload)
  }
}

export default UnitService
